<!-- ProductMediaPickerModal.vue – Refactored to consistent toast shape and tidy layout -->
<template>
  <b-modal
      id="modal-product-attach"
      size="xl"
      title="پیوست فایل به محصول"
      hide-footer
      header-bg-variant="light"
      @hidden="reset"
  >
    <MediaLibraryPicker
        ref="picker"
        :multiple="true"

        :mediaType="mediaType"
        :initial-selected-ids="[]"
    />

    <!-- Attach Options -->
    <b-row class="mt-3">
      <b-col cols="12" md="3">
        <b-form-group>
          <b-form-checkbox v-model="attachIsReachable" switch>
            قابل دسترس
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group>
          <b-form-checkbox v-model="attachIsLocked" switch>
            قفل شده
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="w-100 d-flex justify-content-end align-items-center mt-3">

      <b-button
          variant="primary"
          @click="attachFiles"
      >
        <i v-if="attaching" class="fas fa-spinner fa-spin"></i>
        پیوست فایل‌
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {BButton, BCol, BFormCheckbox, BFormGroup, BFormInput, BModal, BRow} from 'bootstrap-vue'
import MediaLibraryPicker from './MediaLibraryPicker.vue'
import {ProductMediaAttachFileRequest} from '@/libs/Api/ProductMedia'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'ProductMediaPickerModal',
  components: {
    BModal,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    MediaLibraryPicker
  },
  props: {
    productId: {
      type: Number | String,
      required: true
    },
    mediaType: {
      type: Number | String,
      required: false,
      default: ''
    },
    expose: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      visible: false,
      attaching: false,
      attachPriority: 0,
      attachIsMain: false,
      attachIsReachable: true,
      attachIsLocked: false
    }
  },
  computed: {
    hasSelection: function () {
      return this.$refs.picker && this.$refs.picker.selectedIds && this.$refs.picker.selectedIds.length > 0
    },
    selectedCount: function () {
      return this.$refs.picker ? this.$refs.picker.selectedIds.length : 0
    }
  },
  methods: {
    // ===== Toast Helper (consistent with ProductMediaManager) =====
    showToast: function (variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title: title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant: variant,
          text: text
        }
      })
    },
    reset: function () {
      this.attaching = false
      if (this.$refs.picker) {
        this.$refs.picker.resetSelection()
      }
      this.resetForm()
    },
    resetForm: function () {
      this.attachPriority = 0
      this.attachIsMain = false
      this.attachIsReachable = true
      this.attachIsLocked = false
    },
    exposeSelectedIds() {
      this.$emit('exposeSelectedIds', this.$refs.picker.selectedIds)
    },
    // ===== Attach Logic =====
    attachFiles: function () {
      if (this.expose) return this.exposeSelectedIds()
      if (!this.hasSelection) return

      var self = this
      self.attaching = true
      var selectedIds = this.$refs.picker.selectedIds
      var params = {
        productId: this.productId,
        priority: parseInt(this.attachPriority) || 0,
        isMain: this.attachIsMain,
        isReachable: this.attachIsReachable,
        isLocked: this.attachIsLocked
      }

      var requests = selectedIds.map(function (fileId) {
        var request = new ProductMediaAttachFileRequest(self)
        request.setParams({
          fileEntryId: fileId,
          productId: params.productId,
          priority: params.priority,
          isMain: params.isMain,
          isReachable: params.isReachable,
          isLocked: params.isLocked
        })
        return new Promise(function (resolve, reject) {
          request.fetch(
              function (res) {
                resolve(res)
              },
              function (err) {
                reject(err)
              }
          )
        })
      })

      Promise.all(requests)
          .then(function () {
            self.attaching = false
            self.$emit('attached')
            self.showToast('success', 'موفق', selectedIds.length + ' فایل با موفقیت به محصول پیوست شد.')
          })
          .catch(function (error) {
            self.attaching = false
            self.showToast('error', 'خطا', error.message || 'خطا در پیوست فایل‌ها')
          })

      this.$bvModal.hide('modal-product-attach')

    }
  }
}
</script>
